import { Box, Card, CardContent, Divider, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Fragment } from "react";
import Layout from "components/Layout";
import { CHANGELOG } from "constants/changelog";

/** Reachable only by its URL: deliberately not in the side menu yet. */
const ChangelogPage = () => (
  <Layout title="Changelog">
    <Card>
      <CardContent>
        {CHANGELOG.map((release, index) => (
          <Fragment key={release.version}>
            {index > 0 && <Divider sx={{ my: 3 }} />}
            <section>
              <Typography variant="h5" component="h2" gutterBottom>
                {`${release.version} (${dayjs(release.date).format("MMM D, YYYY")})`}
              </Typography>
              <Box component="ul" sx={{ m: 0, pl: 3, listStyleType: "disc" }}>
                {release.changes.map((change) => (
                  <Typography component="li" key={change} sx={{ mb: 0.5 }}>
                    {change}
                  </Typography>
                ))}
              </Box>
            </section>
          </Fragment>
        ))}
      </CardContent>
    </Card>
  </Layout>
);

export default ChangelogPage;
